import { useMutation } from '@tanstack/react-query'
import { ControllingXlsxRequestBody } from '@myapp/contract'
import { controllingApi } from '../controllingApi'

export function useGenerateControllingXlsxMutation() {
  return useMutation({
    mutationFn: (body: ControllingXlsxRequestBody) =>
      controllingApi.generateXlsx(body).then((r) => r.data),
    onSuccess: (blob: Blob) => {
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      const date = new Date().toISOString().slice(0, 10)
      a.download = `controlling-export-${date}.xlsx`
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      URL.revokeObjectURL(url)
    },
  })
}
